var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"page-reports-download-link",attrs:{"href":_vm.href,"download":""},domProps:{"textContent":_vm._s(_vm.$tf('download'))}})}
var staticRenderFns = []

export { render, staticRenderFns }